/* 
 * Export container file to be used on project
*/

import MenuDashboardContainer from './MenuDashboardContainer';
export default MenuDashboardContainer;
